// UAT Branch

// export const API_BASE_URL = 'https://dev.housingram.com/api';
// export const USERMANAGEMENT_API_BASE_URL = 'https://dev.housingram.com/api';
// export const DOCGENERATION_API_BASE_URL = 'https://dev.housingram.com/api';
// export const APPLICATION_API_BASE_URL = 'https://dev.housingram.com/api';
// export const LIVEFEED_API_BASE_URL = 'https://dev.housingram.com/api';
// export const PINCODE_API_BASE_URL = 'https://api.postalpincode.in/pincode';

// production Branch

export const API_BASE_URL = 'https://application.housingram.com/api';
export const USERMANAGEMENT_API_BASE_URL = 'https://application.housingram.com/api';
export const DOCGENERATION_API_BASE_URL = 'https://application.housingram.com/api';
export const APPLICATION_API_BASE_URL = 'https://application.housingram.com/api';
export const LIVEFEED_API_BASE_URL = 'https://application.housingram.com/api';
export const PINCODE_API_BASE_URL = 'https://api.postalpincode.in/pincode';
